const mixin = {
  methods: {
    confirmresult () {
      if (!this.$store.state.simulation.currentSimulation.has_resultat) {
        return Promise.resolve(true)
      }

      return this.confirm({
        title: 'Enregistrement',
        message:
          'Attention, le changement de paramétrage de votre simulation va entrainer la suppression des résultats obtenus après votre précédent appel moteur. Souhaitez-vous tout de même continuer ?',
        okText: 'Confirmer',
        cancelText: 'Annuler'
      }).then(confirmation => {
        if (confirmation) {
          return Promise.resolve(true)
        }
        return Promise.resolve(false)
      })
    }
  }
}
export default mixin
